import { Condition } from "../../components";
import * as Types from "../types";

export const ConditionField: React.FC<Omit<Types.ConditionField, "type" | "fields">> = Condition;
